import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../components/Navbar";

export default function Invite(props) {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/settings/send_invite", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        toast.success("Приглашение отправлено успешно!");
        setEmail("");
      } else {
        toast.error("Не удалось отправить приглашение.");
      }
    } catch (error) {
      toast.error("Произошла ошибка. Попробуйте снова.");
    }
  };

  return (
    <div className="min-h-full bg-gray-50">
      <ToastContainer />
      <div className="pb-20">
        <Navbar props={props} />
      </div>

      {/* Основной контент */}
      <main className="flex justify-center items-center">
        <div className="bg-white shadow-md rounded-lg p-6 w-full max-w-md">
          <h2 className="text-xl font-semibold mb-4 text-gray-700">
            Отправить приглашение
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <label htmlFor="email" className="block text-gray-600">
              Введите e-mail, на который будет отправлено приглашение:
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="example@domain.com"
              required
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
            />
            <div className="flex justify-end gap-2">
              <button
                type="submit"
                className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600"
              >
                Отослать
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
